import _ from "lodash";
import {
  UPDATE_FILTER_MEDIAGROUPS,
  UPDATE_FILTER_SEGMENTS,
  UPDATE_FILTER_CATEGORIES,
  UPDATE_FILTER_TARGETS,
  UPDATE_FILTER_SEARCH,
  UPDATE_FILTER_AGE,
  UPDATE_FILTER_GENDER,
  UPDATE_FILTER_REACH,
  UPDATE_FILTER_BUDGET
} from "./types";

export default function(state = {}, action) {
  switch (action.type) {
    case UPDATE_FILTER_MEDIAGROUPS:
    case UPDATE_FILTER_SEGMENTS:
    case UPDATE_FILTER_CATEGORIES:
    case UPDATE_FILTER_TARGETS:
    case UPDATE_FILTER_SEARCH:
    case UPDATE_FILTER_AGE:
    case UPDATE_FILTER_GENDER:
    case UPDATE_FILTER_REACH:
    case UPDATE_FILTER_BUDGET:
      return { ...state, [action.type]: action.value };
      break;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/data/filters/reducer.js